const headRowsUsers = {
  name: 'Name',
  email: 'E-mail',
  role: 'Type of Access',
  site: 'Sites',
  lastLogin: 'Last acess'
};

export default headRowsUsers;
